<script>
    import {_} from "svelte-i18n";
    import {push} from "svelte-spa-router";
</script>


<div class="rowHighlights">
    <div class="pCursor explore " on:click={() => window.location.href = $_("collection_stories_link")}>
        <img
                src={$_("collection_image")}
                class=" explore unset imageBlur"
                alt={$_("collection_stories")}
        />
        <div class="headline-xs">{$_("collection_stories")}</div>
    </div>
    <div class="divider-v div-mondrian pCursor"/>
    <div class="pCursor highlights" on:click={() => window.location.href = "https://www.fondationbeyeler.ch/museum/architektur-und-natur"}>
        <img
                src="./images/dashboard/park.jpg"
                class="mondrian unset imageBlur"
                alt="#Explore Fondation"
        />
        <div class="headline-xs">
            {$_("park-tag")}
        </div>
    </div>
</div>
<div>
    <div class="divider-h family-divider "/>
</div>

<style>
    .rowHighlights {
        display: flex;
        flex-direction: row;
        margin-top: 24px;
        margin-bottom: 23px;
        width: 100%;
    }

    .mondrian {
        object-fit: cover;
        width: 100%;
        height: 110px;
        margin-bottom: 8px;
        display: block;
    }

    .explore {
        object-fit: cover;
        width: 100%;
        height: 91px;
        margin-bottom: 8px;
        display: block;
    }

    .div-mondrian {
        height: unset;
        align-self: stretch;
        margin-left: 16px;
        margin-right: 16px;
    }

    .highlights {
        width: 100%;
        flex-basis: 58.5%;
    }

    .explore {
        width: 100%;
        flex-basis: 41.5%;
    }

    @media only screen and (min-width: 530px) {
        .mondrian {
            height: 200px;
        }

        .explore {
            height: 170px;
        }
    }

    @media only screen and (min-width: 800px) {
        .rowHighlights {
            margin: 0px;
            margin-top: 42px;
        }

        .family-divider {
            display: none;
        }

        .explore {
            width: 100%;
            height: 170px;
            margin-bottom: 16px;
        }

        .mondrian {
            width: 100%;
            height: 200px;
            margin-bottom: 16px;
        }

        .div-mondrian {
            margin: 0 24px;
        }
    }

    @media only screen and (min-width: 1080px) {
        .mondrian {
            height: 469px;
        }

        .explore {
            height: 400px;
        }
    }


</style>

